import React from 'react';
import { Lightning, Gauge, Star } from '@phosphor-icons/react';
import { getCategoryColor, getCategoryLabel } from 'config/ideaCategories';

export default function QuickWinsSlide({ sectionNumber, ideas }) {
    // Sort by combined score (impact + ease) and take top 5
    const topIdeas = [...ideas]
        .map(idea => ({
            ...idea,
            ease: idea.ease || (10 - idea.difficulty + 1),
            combinedScore: idea.impact + (idea.ease || (10 - idea.difficulty + 1))
        }))
        .sort((a, b) => b.combinedScore - a.combinedScore)
        .slice(0, 5);

    return (
        <div className="h-full w-full bg-[#1a1a1a] p-8 md:p-16 overflow-y-auto relative">
            {/* Logo */}
            <div className="absolute top-8 right-8 md:top-16 md:right-16">
                <img
                    src="/images/opificioai-logo-white.png"
                    alt="OpificioAI"
                    className="h-6 md:h-8 w-auto opacity-60"
                />
            </div>

            <div className="max-w-6xl mx-auto">
                {/* Section Number */}
                <div className="text-[80px] md:text-[120px] font-bold text-white/10 leading-none mb-4">
                    {sectionNumber}
                </div>

                <div className="flex items-center gap-4 mb-12">
                    <Star size={40} weight="fill" className="text-amber-400" />
                    <h2 className="text-3xl md:text-5xl font-bold text-white">
                        Quick Wins
                    </h2>
                </div>

                <p className="text-lg text-white/50 mb-12">
                    Le idee con il miglior rapporto impatto/facilità di implementazione
                </p>

                {/* Ideas List */}
                <div className="space-y-4">
                    {topIdeas.map((idea, index) => {
                        const color = getCategoryColor(idea.category);
                        return (
                            <div
                                key={idea._id || index}
                                className="bg-white/10 backdrop-blur rounded-2xl p-6 flex items-start gap-6"
                            >
                                <div className="text-4xl font-bold text-white/20">
                                    {index + 1}
                                </div>

                                <div className="flex-1">
                                    <div className="flex items-center gap-3 mb-2">
                                        <div
                                            className="w-3 h-3 rounded-full"
                                            style={{ backgroundColor: color }}
                                        />
                                        <span className="text-xs font-medium text-white/40 uppercase tracking-wider">
                                            {getCategoryLabel(idea.category)}
                                        </span>
                                    </div>

                                    <h3 className="text-xl font-semibold text-white mb-2">
                                        {idea.title}
                                    </h3>

                                    {idea.description && (
                                        <p className="text-white/50 text-sm line-clamp-2">
                                            {idea.description}
                                        </p>
                                    )}
                                </div>

                                <div className="flex flex-col items-end gap-2">
                                    <div className="flex items-center gap-2">
                                        <Lightning size={16} weight="fill" className="text-amber-400" />
                                        <span className="text-lg font-bold text-white">{idea.impact}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Gauge size={16} weight="fill" className="text-emerald-400" />
                                        <span className="text-lg font-bold text-white">{idea.ease}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
